import { PublisherErrorHandler, } from './publisher-error-handler';
const handlers = [];
const context = require.context('./publisher-error-handlers', true, /\.ts/u);
for (const key of context.keys()) {
    const module = context(key).default;
    if (module.prototype instanceof PublisherErrorHandler) {
        handlers.push(module);
    }
}
export class OtPublisherErrorHandler {
    constructor($injector) {
        this.errorHandlers = [];
        const $log = $injector.get('$log');
        this.debug = $log.debug.bind($log, 'OtPublisherErrorHandler:');
        this.errorHandlers = handlers.map((handler) => new handler($injector));
    }
    onError(err) {
        this.debug('onError', err);
        const errorHandler = this.errorHandlers.find((handler) => handler.errorName === err.name);
        errorHandler?.onError(err);
    }
    onSuccess() {
        this.debug('onSuccess');
        for (const errorHandler of this.errorHandlers) {
            errorHandler.onSuccess();
        }
    }
}
